// src/marketing/editorial/DocHeader.tsx
import { JSX } from 'react'

type Props = {
  no: string
  title: string
  meta?: string
}

export function DocHeader({ no, title, meta }: Props): JSX.Element {
  return (
    <div className="doc-head">
      <span className="doc-no">{no}</span>
      <h1>{title}</h1>
      {meta !== undefined && <span className="doc-meta">{meta}</span>}
    </div>
  )
}
